import {Repository, createRepository} from '@/repositories/Base/Repository'

class ReportTrashRepository extends Repository {
    endpoint = 'vns/report_trash'

    fetchAll(params) {
        return this.$axios.get(`${this.endpoint}/table`, {params})
    }

    fetchByVns(id) {
        return this.$axios.get(`${this.endpoint}/${id}/vns`)
    }

    postByVns(id, params) {
        return this.$axios.post(`${this.endpoint}/postByVns`, {...params, id: id})
    }
}

export default new ReportTrashRepository()

export const create = createRepository(ReportTrashRepository)
